import React from 'react';

// Preview page - lists only the metrics the user has confirmed for ranking so far.
// Once approved, these get wired into DistrictRanking.jsx and the "Rank by" dropdown.

const METRICS = [
  {
    section: 'Section 4 - School Admission (ADW)',
    items: [
      { label: 'Class X Pass % (2025-26) - Total' },
      { label: 'Class XII Pass % (2025-26) - Total' },
    ],
  },
  {
    section: 'Section 4 - School Admission (TW)',
    items: [
      { label: 'Class X Pass % (2025-26) - Total' },
      { label: 'Class XII Pass % (2025-26) - Total' },
    ],
  },
  {
    section: 'Section 5 - Hostel (ADW)',
    items: [
      { label: 'Number of Online Devices (number & %)' },
      { label: 'Average Daily Attendance %' },
      { label: 'Students with attendance below 75% (%)' },
      { label: 'DADWO Inspections Pending (number & %)' },
      { label: 'ST Inspections Pending (number & %)' },
    ],
  },
  {
    section: 'Section 5 - Hostel (TW)',
    items: [
      { label: 'Number of Online Devices (number & %)' },
      { label: 'Average Daily Attendance %' },
      { label: 'Students with attendance below 75% (%)' },
      { label: 'DADWO Inspections Pending (number & %)' },
      { label: 'ST Inspections Pending (number & %)' },
    ],
  },
  {
    section: 'Section 6 - Land Pattas',
    items: [
      { label: 'Total number of fields yet to be surveyed' },
      { label: 'Land yet to be converted to AD Natham' },
      { label: 'Eligible but not yet patta given' },
      { label: 'Applications not yet scrutinised' },
      { label: 'Number of e-pattas yet to be issued' },
    ],
  },
  {
    section: 'Section 7 - Court Cases',
    items: [
      { label: 'Court Cases Pending' },
    ],
  },
  {
    section: 'Section 8 - CM Cell Petitions',
    items: [
      { label: 'Number of CM Cell Petitions - Total Pending' },
    ],
  },
  {
    section: 'Section 9 - RTI',
    items: [
      { label: 'RTI Pending' },
    ],
  },
  {
    section: 'Section 11.1 - SC Habitations',
    items: [
      { label: 'No. of SC Habitations without dedicated Burial Grounds' },
      { label: 'No. of SC Habitations without Pathways' },
    ],
  },
  {
    section: 'Section 11.2 - ST Habitations (Burial Grounds / Crematorium issues)',
    items: [
      { label: 'No. of ST Habitations without dedicated Burial Grounds' },
      { label: 'No. of ST Habitations without Pathways' },
    ],
  },
  {
    section: 'Section 12 - Transport Access / Water',
    items: [
      { label: 'No. of Habitations without public transport access' },
      { label: 'No. of Habitations without All Weather Roads' },
      { label: 'No. of Habitations without Drinking Water' },
      { label: 'No. of Habitations without Mobile network access' },
      { label: 'No. of Habitations without Electricity' },
      { label: 'No. of ST Households without Electricity' },
    ],
  },
  {
    section: 'Section 14 - DAPSC/ST - DMC Meetings',
    items: [
      { label: 'DMC Meeting Status - Quarter 1 (Conducted / Not Conducted)' },
      { label: 'DMC Meeting Status - Quarter 2 (Conducted / Not Conducted)' },
      { label: 'DMC Meeting Status - Quarter 3 (Conducted / Not Conducted)' },
      { label: 'DMC Meeting Status - Quarter 4 (Conducted / Not Conducted)' },
    ],
  },
  {
    section: 'Section 15 - Community Certificate',
    items: [
      { label: 'How many applications are Pending?' },
    ],
  },
  {
    section: 'Section 18A - District Level Vigilance Monitoring Committee (DLVMC)',
    items: [
      { label: 'DLVMC Status - Quarter 1 (Conducted / Not Conducted)' },
      { label: 'DLVMC Status - Quarter 2 (Conducted / Not Conducted)' },
      { label: 'DLVMC Status - Quarter 3 (Conducted / Not Conducted)' },
      { label: 'DLVMC Status - Quarter 4 (Conducted / Not Conducted)' },
    ],
  },
  {
    section: 'Section 18B - Sub-divisional Level Vigilance Monitoring Committee (SDLVMC)',
    items: [
      { label: 'SDLVMC Status - Quarter 1 (Subdivision - Conducted / Not Conducted)' },
      { label: 'SDLVMC Status - Quarter 2 (Subdivision - Conducted / Not Conducted)' },
      { label: 'SDLVMC Status - Quarter 3 (Subdivision - Conducted / Not Conducted)' },
      { label: 'SDLVMC Status - Quarter 4 (Subdivision - Conducted / Not Conducted)' },
    ],
  },
  {
    section: 'Section 19 - POA Claims',
    items: [
      { label: 'Cases pending Monetary Relief (Stage 1)' },
      { label: 'Cases pending Monetary Relief (Stage 2)' },
      { label: 'Cases pending Monetary Relief (Stage 3)' },
      { label: 'Cases pending Additional Relief (Job)' },
      { label: 'Cases pending Additional Relief (Pension)' },
      { label: 'Cases pending Additional Relief (Patta)' },
    ],
  },
  {
    section: 'Section 20 - Loan Applications (Pending)',
    items: [
      { label: 'Vetri Thozhil Munaivor Thittam - Pending' },
      { label: 'PM-AJAY Subsidy - Pending' },
      { label: 'Mannin Magal Thittam - Pending' },
      { label: 'Education Loan - NSKFDC (Safai Karmachari) - Pending' },
      { label: 'Education Loan - NSTFDC (ST) - Pending' },
      { label: 'Education Loan - NSFDC (SC) - Pending' },
      { label: 'Micro Credit Finance - Pending' },
    ],
  },
  {
    section: 'Section 21 - Construction Status',
    items: [
      { label: 'Hostel - Under Construction' },
      { label: 'Hostel - Not Yet Started' },
      { label: 'School - Under Construction' },
      { label: 'School - Not Yet Started' },
      { label: 'Community Hall (Village Knowledge Center) - Under Construction' },
      { label: 'Community Hall (Village Knowledge Center) - Not Yet Started' },
    ],
  },
  {
    section: 'Section 22 - FRA (Forest Rights Act)',
    items: [
      { label: 'FRC Verification Pending' },
      { label: 'Claims pending for resolution (to be submitted to SDLC)' },
      { label: 'Claims pending with SDLC' },
      { label: 'Claims pending with DLC' },
      { label: 'Titles pending' },
    ],
  },
];

const RankingMetricsPreview = () => {
  return (
    <div style={{ padding: '24px', background: '#f7f8fb', minHeight: '100vh' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <h1 style={{ margin: 0, color: '#1f2937' }}>Ranking Metrics - Preview</h1>
        <p style={{ color: '#6b7280', marginTop: 6 }}>
          These are the metrics confirmed so far for the District Ranking. Review and confirm - once you say OK,
          these will be moved into the ranking calculation and the "Rank by" dropdown.
        </p>

        {METRICS.map((group) => (
          <div key={group.section} style={{ marginTop: 28 }}>
            <h2 style={{ fontSize: 18, color: '#111827', margin: '0 0 12px' }}>{group.section}</h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
              gap: 14,
            }}>
              {group.items.map((m, i) => (
                <div key={i} style={{
                  background: '#fff',
                  border: '1px solid #e5e7eb',
                  borderLeft: '4px solid #ec4899',
                  borderRadius: 8,
                  padding: 14,
                  boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
                }}>
                  <div style={{ fontWeight: 600, color: '#111827' }}>{m.label}</div>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div style={{
          marginTop: 32,
          padding: 14,
          background: '#fef3c7',
          border: '1px solid #fcd34d',
          borderRadius: 8,
          color: '#92400e',
          fontSize: 13,
        }}>
          Total metrics listed: <b>{METRICS.reduce((s, g) => s + g.items.length, 0)}</b>. Add more sections
          by telling me the metric list and I'll extend this page before we commit to ranking.
        </div>
      </div>
    </div>
  );
};

export default RankingMetricsPreview;
